module.exports = __webpack_public_path__ + "media/images/syntax_logo_white-99a4b41584f4cc45399ead606235d2fb.svg";